import { render, staticRenderFns } from "./CleanerOrders.vue?vue&type=template&id=c978f240"
import script from "./CleanerOrders.vue?vue&type=script&lang=js"
export * from "./CleanerOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports